export default "__VITE_ASSET__Cn4QxnRn__"